/* SHARKER · movimiento y rapidez de la web (06-10-2026). Regla de Raúl: «cada toque tiene que ser instantáneo».
   1. Al tocar una prenda se va directamente a su ficha, sin animaciones; las fotos grandes de las prendas que se ven
      se descargan por adelantado y la ficha se pide al apoyar el dedo, así sale entera de golpe.
   2. Tarjetas y títulos entran con suavidad al bajar, escalonados. Lo que ya se ve al abrir no se esconde nunca.
   3. La bolsa de la cabecera se llena hasta el envío gratis. Al pulsar «Añadir al carrito», el carrito se abre YA con
      la prenda dentro; Shopify confirma por detrás y el carrito real sustituye al provisional.
   4. Ficha en el móvil: barra fija «Añadir al carrito» cuando el botón queda atrás.
   5. Sharky TV: los vídeos se descargan al acercarse y solo se mueve el que está a la vista.
   6. Huevo de pascua en la portada: 5 toques al logo y Sharky cruza nadando.
   Si el navegador no tiene alguna de estas funciones o el cliente pide menos movimiento, esa parte no se hace. */
(function () {
  'use strict';
  var D = document, H = D.documentElement, W = window;
  var RM = !!(W.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var C = W.SHK_CINE || {};
  var UMBRAL = +C.umbral || 7000;
  function $(s, c) { return (c || D).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); }
  function esFicha() { return D.body && D.body.classList.contains('template-product'); }

  /* ---------- 1. Fichas que abren al momento, sin animaciones ----------
     Al tocar una prenda se va directamente a su ficha (como MStudios o Nude Project). Para que salga entera de golpe:
     - la foto grande de las prendas que el cliente tiene delante (más de medio segundo a la vista) se descarga por
       adelantado, con la misma dirección que usa la ficha: al entrar, la foto ya está;
     - al apoyar el dedo en una prenda se pide ya su ficha y su foto (unos 100-200 ms antes de soltar).
     En Chrome/Android, Shopify además precarga la página de las fichas que se ven; Safari todavía no lo permite. */
  var pedidas = {}, fotos = {}, nFotos = 0;
  var ahorroDatos = !!(navigator.connection && navigator.connection.saveData);
  function enlaceFicha(t) {
    if (!t || !t.closest) return '';
    var a = t.closest('a[href*="/products/"]');
    if (a && a.href) return a.href;
    var card = t.closest('.ProductItem'); var l = card && $('a[href*="/products/"]', card);
    return l ? l.href : '';
  }
  /* La foto de la ficha: la misma imagen de la tarjeta a 1200 px y calidad 75 (la que precarga la ficha en iPhone) */
  function fotoFicha(card) {
    var img = card && ($('img.ProductItem__Image:not(.ProductItem__Image--alternate)', card) || $('img', card));
    var src = img ? (img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '') : '';
    if (!/[?&]width=(\d+|\{width\})/.test(src)) return '';
    return src.replace(/([?&])width=(\d+|\{width\})(&quality=\d+)?/, '$1width=1200&quality=75');
  }
  function precargaFoto(url) {
    if (!url || fotos[url] || nFotos >= 16 || ahorroDatos) return;
    fotos[url] = 1; nFotos++;
    var i = new Image(); i.decoding = 'async'; i.src = url;
  }
  function pideFicha(url) {
    if (!url || pedidas[url] || ahorroDatos) return;
    pedidas[url] = 1;
    try { fetch(url, { credentials: 'same-origin', priority: 'low' }).catch(function () {}); } catch (e) {}
  }
  D.addEventListener('pointerdown', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var url = enlaceFicha(t); if (!url) return;
    pideFicha(url);
    precargaFoto(fotoFicha(t.closest('.ProductItem, .shk-int__it, .shk-tv__it')));
  }, { passive: true, capture: true });
  function fotosALaVista() {
    if (ahorroDatos || !('IntersectionObserver' in W)) return;
    var esperas = new Map();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var card = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.6) {
          if (!esperas.has(card)) esperas.set(card, setTimeout(function () { precargaFoto(fotoFicha(card)); io.unobserve(card); }, 500));
        } else if (esperas.has(card)) { clearTimeout(esperas.get(card)); esperas.delete(card); }
      });
    }, { threshold: [0, 0.6] });
    $$('.ProductItem').forEach(function (c) { io.observe(c); });
  }

  /* ---------- 2. Entradas suaves al bajar ----------
     Se mira en cada scroll (no con un observador): así lo que se salta de golpe (volver atrás, «ir arriba», un
     enlace a media página) aparece igual y nunca se queda nada escondido. */
  var ENTRAN = '.SectionHeader, .ProductList .ProductItem, .shk-imgrow__col, .shk-nl__copy, .shk-nl__form-wrap';
  var pendientes = [], mirando = false;
  function revela() {
    mirando = false;
    var alto = W.innerHeight || 800, lote = [];
    pendientes = pendientes.filter(function (el) {
      if (!el.isConnected) return false;
      var r = el.getBoundingClientRect();
      if (r.top < alto * 0.94) { lote.push([el, r]); return false; }
      return true;
    });
    lote.sort(function (x, y) { return (x[1].top - y[1].top) || (x[1].left - y[1].left); });
    lote.forEach(function (par, i) {
      var el = par[0], fuera = par[1].bottom < 0;
      el.style.transitionDelay = fuera ? '0ms' : Math.min(i, 6) * 70 + 'ms';
      el.classList.add('shk-in');
      setTimeout(function () { el.style.transitionDelay = ''; el.classList.remove('shk-rev', 'shk-in'); }, 1500);
    });
    if (!pendientes.length) { W.removeEventListener('scroll', alMover); W.removeEventListener('resize', alMover); }
  }
  function alMover() { if (!mirando) { mirando = true; requestAnimationFrame(revela); } }
  function armaEntradas() {
    if (RM) return;
    var alto = W.innerHeight || 800, nuevos = 0;
    $$(ENTRAN).forEach(function (el) {
      if (el.__shkRev) return; el.__shkRev = true;
      var r = el.getBoundingClientRect();
      if (!r.height || r.top < alto * 0.95) return; /* ya se ve, está por encima o está oculta: no se toca */
      el.classList.add('shk-rev'); pendientes.push(el); nuevos++;
    });
    if (nuevos) { W.addEventListener('scroll', alMover, { passive: true }); W.addEventListener('resize', alMover); }
  }

  /* ---------- 3. La bolsa: nivel hasta el envío gratis, contador y prenda que vuela ----------
     A cada icono de bolsa que lleva al carrito (cabecera, cabecera fija, portada, buscador y menú) se le mete por
     dentro un relleno rosa que sube con el importe, un ✓ cuando llega al envío gratis y el número de prendas. */
  var NS = 'http://www.w3.org/2000/svg', nBolsa = 0;
  function preparaBolsas() {
    $$('a[data-drawer-id="sidebar-cart"], a[href="/cart"], a[href$="/cart"]').forEach(function (a) {
      var svg = $('svg', a); if (!svg || svg.__shk) return;
      var cuerpo = $('path[d^="M6 2L3 6v14"]', svg); if (!cuerpo) return;
      svg.__shk = true; nBolsa += 1;
      var id = 'shk-bolsa-' + nBolsa;
      var defs = D.createElementNS(NS, 'defs'), clip = D.createElementNS(NS, 'clipPath'), forma = D.createElementNS(NS, 'path');
      clip.setAttribute('id', id); forma.setAttribute('d', cuerpo.getAttribute('d'));
      clip.appendChild(forma); defs.appendChild(clip);
      var nivel = D.createElementNS(NS, 'rect');
      nivel.setAttribute('class', 'shk-bolsa__nivel'); nivel.setAttribute('clip-path', 'url(#' + id + ')');
      nivel.setAttribute('x', '2'); nivel.setAttribute('y', '22'); nivel.setAttribute('width', '20'); nivel.setAttribute('height', '21');
      var ok = D.createElementNS(NS, 'path');
      ok.setAttribute('class', 'shk-bolsa__ok'); ok.setAttribute('d', 'M9.2 16.4l2 2 3.8-3.8');
      svg.insertBefore(nivel, svg.firstChild); svg.insertBefore(defs, nivel); svg.appendChild(ok);
      var n = D.createElement('span'); n.className = 'shk-bolsa__n'; n.hidden = true;
      a.appendChild(n); a.classList.add('shk-bolsa'); a.setAttribute('data-shk-bolsa', '');
    });
  }
  var total0 = +C.total || 0, n0 = +C.n || 0;
  function pintaBolsa(total, n, inmediato) {
    total0 = total; n0 = n;
    var lleno = Math.max(0, Math.min(1, total / UMBRAL)), y = 22 - 16 * lleno;
    $$('[data-shk-bolsa]').forEach(function (b) {
      var r = $('.shk-bolsa__nivel', b), c = $('.shk-bolsa__n', b);
      if (r) {
        var y0 = parseFloat(r.getAttribute('y')) || 22, t0 = 0;
        if (RM || inmediato || Math.abs(y0 - y) < 0.05) r.setAttribute('y', y.toFixed(2));
        else requestAnimationFrame(function paso(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 700), ease = 1 - Math.pow(1 - k, 3); r.setAttribute('y', (y0 + (y - y0) * ease).toFixed(2)); if (k < 1) requestAnimationFrame(paso); });
      }
      if (c) { c.textContent = n > 0 ? n : ''; c.hidden = !(n > 0); }
      var llena = total >= UMBRAL && n > 0, antes = b.classList.contains('is-llena');
      b.classList.toggle('is-llena', llena);
      if (llena && !antes && !RM && !inmediato) { b.classList.remove('shk-bolsa--fiesta'); void b.offsetWidth; b.classList.add('shk-bolsa--fiesta'); }
    });
  }
  /* ---------- Carrito al instante ----------
     Al pulsar «Añadir al carrito» (ficha) o «Añadir» (Sharky), el carrito se abre en el acto con la prenda ya dentro,
     pintada con los datos que ya hay en la página. Shopify añade por detrás; cuando confirma, cart-drawer recarga
     /cart?view=drawer y el carrito real sustituye al provisional. Si Shopify dice que no (agotada…), se quita y se avisa. */
  var provisional = null;
  function dinero(c) { return '€' + (Math.round(c) / 100).toFixed(2).replace('.', ',').replace(/,00$/, ''); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function carritoAlInstante() {
    D.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.ProductForm__AddToCart');
      if (!btn || btn.disabled || typeof W.shkCartOpen !== 'function') return;
      var form = btn.closest('form'), campo = form && $('[name="id"]', form);
      if (!campo || !campo.value) return;
      var datos = null;
      try { datos = JSON.parse(($('[data-product-json]') || {}).textContent || 'null'); datos = datos && datos.product; } catch (x) {}
      var id = parseInt(campo.value, 10), v = datos && datos.variants ? datos.variants.filter(function (x) { return x.id === id; })[0] : null;
      if (!v || !v.available) return;
      var cant = Math.max(1, parseInt(($('[name="quantity"]', form) || {}).value, 10) || 1);
      var foto = $('.Product__SlideItem.is-selected .AspectRatio > img') || $('.Product__Gallery img');
      W.shkCartProvisional({
        titulo: datos.title || '', talla: datos.variants.length > 1 ? v.title : '', precio: v.price * cant, cant: cant,
        foto: foto ? (foto.currentSrc || foto.src) : ''
      });
    }, true);
  }
  /* También la usa el «¿Qué te llevas?» de Sharky (assets/shk-sharky.js) */
  W.shkCartProvisional = function (p) {
    var cart = $('#sidebar-cart'); if (!cart || typeof W.shkCartOpen !== 'function') return;
    var scroll = $('.shk-scroll', cart);
    if (scroll) {
      var lista = $('.shk-items', scroll);
      if (!lista) { var vacio = $('.shk-empty', scroll); if (vacio) vacio.remove(); lista = D.createElement('div'); lista.className = 'shk-items'; scroll.appendChild(lista); }
      /* Si esa talla ya estaba en el carrito, se suma a su línea en vez de poner otra */
      var igual = $$('.shk-item', lista).filter(function (it) {
        var n = $('.shk-item__name', it), t = $('.shk-item__variant', it);
        return n && n.textContent.trim().toLowerCase() === String(p.titulo).trim().toLowerCase() && (t ? t.textContent.trim() : '') === (p.talla || '');
      })[0];
      if (igual) {
        var num = $('.shk-qty__num', igual); if (num) num.textContent = (parseInt(num.textContent, 10) || 0) + p.cant;
        provisional = { el: igual, nuevo: false, cant: p.cant, num: num };
      } else {
        var it = D.createElement('div'); it.className = 'shk-item shk-item--prov';
        it.innerHTML = '<a><img class="shk-item__img" src="' + esc(p.foto) + '" alt=""></a><div class="shk-item__body"><div class="shk-item__top"><div>' +
          '<span class="shk-item__name">' + esc(p.titulo) + '</span>' + (p.talla ? '<span class="shk-item__variant">' + esc(p.talla) + '</span>' : '') +
          '</div></div><div class="shk-item__bottom"><div class="shk-qty"><span class="shk-qty__num">' + p.cant + '</span></div><div><span class="shk-price">' + dinero(p.precio) + '</span></div></div></div>';
        lista.insertBefore(it, lista.firstChild);
        provisional = { el: it, nuevo: true };
      }
    }
    /* Barra de envío gratis y bolsa de la cabecera, ya con la prenda */
    var total = total0 + p.precio, ship = $('.shk-ship', cart);
    if (ship) {
      ship.hidden = false;
      var fill = $('.shk-ship__fill', ship); if (fill) fill.style.width = Math.min(100, Math.round(total * 100 / UMBRAL)) + '%';
      var txt = $('p', ship);
      if (txt) txt.innerHTML = total >= UMBRAL ? 'Has conseguido <strong>ENVÍO GRATIS</strong>' : 'Te faltan <strong>' + dinero(UMBRAL - total) + '</strong> para <strong>ENVÍO GRATIS</strong>';
    }
    pintaBolsa(total, n0 + p.cant);
    W.shkCartOpen();
  };
  function quitaProvisional(motivo) {
    if (!provisional) return;
    var p = provisional; provisional = null;
    if (p.el.isConnected) {
      if (p.nuevo) p.el.remove();
      else if (p.num) p.num.textContent = Math.max(1, (parseInt(p.num.textContent, 10) || 1) - p.cant);
    }
    var scroll = $('#sidebar-cart .shk-scroll');
    if (scroll && motivo) {
      var aviso = D.createElement('p'); aviso.className = 'shk-aviso'; aviso.textContent = motivo;
      scroll.insertBefore(aviso, scroll.firstChild);
      setTimeout(function () { aviso.remove(); }, 5000);
    }
    leeCarrito().then(function (c) { if (c) pintaBolsa(c.total_price, c.item_count); }).catch(function () {});
  }

  function leeCarrito() { return fetch0('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  var fetch0 = W.fetch ? W.fetch.bind(W) : null;
  function trasCambio(url, ok, motivo) {
    var esAdd = /\/cart\/add/.test(url);
    if (!ok) { if (esAdd) quitaProvisional(motivo || 'No se ha podido añadir. Prueba otra vez.'); return; }
    if (esAdd) provisional = null; /* el carrito real llega por product:added y sustituye al provisional */
    leeCarrito().then(function (c) { if (c) pintaBolsa(c.total_price, c.item_count); }).catch(function () {});
  }
  function esCarrito(u) { return typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u); }
  if (fetch0) {
    W.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = fetch0.apply(W, arguments);
      if (esCarrito(url)) p.then(function (r) {
        if (r && r.ok) { trasCambio(url, true); return; }
        /* Shopify explica el motivo (p. ej. «Ya no quedan más unidades») en description */
        (r ? r.clone().json() : Promise.reject()).then(function (j) { trasCambio(url, false, j && (j.description || j.message)); }, function () { trasCambio(url, false); });
      }).catch(function () { trasCambio(url, false); });
      return p;
    };
  }
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__shkUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (esCarrito(x.__shkUrl)) {
      x.addEventListener('load', function () { trasCambio(x.__shkUrl, x.status >= 200 && x.status < 300); });
      x.addEventListener('error', function () { trasCambio(x.__shkUrl, false); });
    }
    return xs.apply(this, arguments);
  };
  W.addEventListener('pageshow', function (e) { if (e.persisted && fetch0) leeCarrito().then(function (c) { if (c) pintaBolsa(c.total_price, c.item_count); }).catch(function () {}); });

  /* ---------- 4. Barra fija «Añadir al carrito» en la ficha (móvil) ----------
     Aparece cuando el botón principal ha quedado arriba. Si el cliente todavía no ha elegido talla, el botón de la
     barra lleva a las tallas en vez de añadir la que viene marcada por defecto (así nadie compra una talla sin querer). */
  function barraFicha() {
    /* El tema cambia el botón principal al elegir talla: se busca de nuevo cada vez, nunca se guarda */
    function boton() { return $('.Product__Info .ProductForm__AddToCart') || $('.ProductForm__AddToCart'); }
    var form = boton() && boton().closest('form');
    if (!esFicha() || !form) return;
    var radios = $$('.SizeSwatch__Radio, .ColorSwatch__Radio', form);
    var tallas = $$('input[name^="option-"]', form).length > 1 || $$('select[name^="option"], .ProductForm__Variants select', form).length > 0;
    var elegida = !tallas;
    var titulo = ($('.ProductMeta__Title') || {}).textContent || '';
    var precio = $('.ProductMeta__PriceList .ProductMeta__Price:not(.Price--compareAt)') || $('.ProductMeta__Price');
    var foto = $('.Product__SlideItem.is-selected .AspectRatio > img') || $('.Product__Gallery img');
    var barra = D.createElement('div');
    barra.className = 'shk-barra'; barra.id = 'shk-barra'; barra.setAttribute('aria-hidden', 'true');
    barra.innerHTML = '<img class="shk-barra__foto" alt="" width="44" height="55"><div class="shk-barra__info"><b></b><span></span></div><button type="button" class="shk-barra__btn"></button>';
    var bImg = $('.shk-barra__foto', barra), bTit = $('b', barra), bSub = $('span', barra), bBtn = $('.shk-barra__btn', barra);
    if (foto) bImg.src = foto.currentSrc || foto.src; else bImg.remove();
    bTit.textContent = titulo.trim();
    D.body.appendChild(barra);

    var datos = null;
    try { datos = JSON.parse(($('[data-product-json]') || {}).textContent || 'null'); datos = datos && datos.product; } catch (e) {}
    function varianteActual() {
      var campo = $('[name="id"]', form), id = campo ? parseInt(campo.value, 10) : 0;
      return datos && datos.variants ? datos.variants.filter(function (v) { return v.id === id; })[0] : null;
    }
    function tallaActual() {
      var r = $('input[name^="option-"]:checked', form);
      return r ? r.value : '';
    }
    function pinta() {
      var p = precio ? precio.textContent.trim() : '';
      var t = elegida && tallas ? tallaActual() : '';
      bSub.textContent = p + (t ? ' · Talla ' + t : '');
      var v = varianteActual();
      if (v && !v.available) { bBtn.textContent = 'Agotado'; bBtn.disabled = true; return; }
      bBtn.disabled = false;
      bBtn.textContent = elegida ? 'Añadir al carrito' : 'Elegir talla';
    }
    form.addEventListener('change', function (e) { if (e.isTrusted !== false) elegida = true; setTimeout(pinta, 80); });
    radios.forEach(function (r) { r.addEventListener('click', function () { elegida = true; setTimeout(pinta, 80); }); });
    D.addEventListener('variant:changed', function () { setTimeout(pinta, 80); });
    pinta();

    bBtn.addEventListener('click', function () {
      if (bBtn.disabled) return;
      if (!elegida) {
        var zona = $('.ProductForm__Variants', form) || form;
        var y = zona.getBoundingClientRect().top + W.pageYOffset - 150;
        W.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
        zona.classList.remove('shk-mira'); void zona.offsetWidth; zona.classList.add('shk-mira');
        return;
      }
      var b = boton(); if (!b || b.disabled) return;
      b.click();
    });

    var visible = false;
    function muestra(si) {
      if (si === visible) return; visible = si;
      barra.classList.toggle('is-on', si); barra.setAttribute('aria-hidden', si ? 'false' : 'true');
      H.classList.toggle('shk-barra-on', si);
    }
    /* Se mira en cada scroll (con un salto a «Ver opiniones» un observador podía no enterarse) */
    var pendiente = false;
    function mira() {
      pendiente = false;
      var b = boton(), r = b && b.getBoundingClientRect();
      muestra(!!r && r.bottom < 0 && W.innerWidth < 768);
    }
    function alScroll() { if (!pendiente) { pendiente = true; requestAnimationFrame(mira); } }
    W.addEventListener('scroll', alScroll, { passive: true });
    W.addEventListener('resize', alScroll);
    mira();
  }

  /* ---------- 5. Sharky TV: cada vídeo se descarga al acercarse y solo se mueve el que está a la vista ----------
     Con «ahorro de datos» o «reducir movimiento» no arranca solo: se toca para verlo. Si el cliente lo para, no se
     vuelve a poner en marcha solo. */
  function sharkyTv() {
    var vids = $$('video[data-shk-tv-src]'); if (!vids.length) return;
    var ahorro = !!(navigator.connection && navigator.connection.saveData);
    var auto = !RM && !ahorro && ('IntersectionObserver' in W);
    /* La portada del vídeo tampoco se pide al abrir la página: le quitaría conexión a la foto grande de arriba */
    function portada(v) { var p = v.getAttribute('data-poster'); if (p && !v.getAttribute('poster')) v.setAttribute('poster', p); }
    function carga(v) {
      portada(v);
      if (v.getAttribute('src')) return;
      v.setAttribute('src', v.getAttribute('data-shk-tv-src'));
      /* En la ficha el vídeo empieza donde se ve la prenda y repite solo ese tramo */
      var ini = parseFloat(v.getAttribute('data-inicio'));
      if (ini > 0) {
        v.addEventListener('loadedmetadata', function () { if (v.currentTime < ini) v.currentTime = ini; }, { once: true });
        v.addEventListener('ended', function () { v.currentTime = ini; v.play().catch(function () {}); });
      }
    }
    function marca(v, parado) { var it = v.closest('.shk-tv__it'); if (it) it.classList.toggle('is-parado', parado); }
    vids.forEach(function (v) {
      marca(v, true);
      v.addEventListener('playing', function () { marca(v, false); });
      v.addEventListener('pause', function () { marca(v, true); });
      v.parentNode.addEventListener('click', function () {
        carga(v);
        if (v.paused) { v.__parado = false; v.play().catch(function () {}); } else { v.__parado = true; v.pause(); }
      });
    });
    if (!('IntersectionObserver' in W)) { vids.forEach(portada); return; }
    var portadas = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { portada(e.target); portadas.unobserve(e.target); } });
    }, { rootMargin: '900px 400px' });
    vids.forEach(function (v) { portadas.observe(v); });
    if (!auto) return;
    var cerca = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { carga(e.target); cerca.unobserve(e.target); } });
    }, { rootMargin: '300px 200px' });
    var vista = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.75) { if (!v.__parado) { carga(v); v.play().catch(function () {}); } }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.75] });
    vids.forEach(function (v) { cerca.observe(v); vista.observe(v); });
  }

  /* ---------- 6. Huevo de pascua (solo portada): 5 toques rápidos al logo y Sharky cruza la pantalla nadando ----------
     La animación (WebP animado con fondo transparente, hecha con Higgsfield + Seedance 2.5) solo se descarga cuando
     alguien empieza a tocar el logo. En la portada, el primer toque sube arriba del todo en vez de recargar la página. */
  function huevo() {
    if (!D.body || !D.body.classList.contains('template-index') || !C.huevo) return;
    var toques = 0, reloj = 0, nadando = false, img = null;
    function precarga() { if (!img) { img = new Image(); img.decoding = 'async'; img.src = C.huevo; } }
    function nada() {
      if (nadando) return; nadando = true;
      var alto = W.innerHeight, ancho = W.innerWidth;
      var tam = Math.round(Math.min(Math.max(ancho * 0.55, 220), 420));
      var capa = D.createElement('div'); capa.className = 'shk-huevo'; capa.setAttribute('aria-hidden', 'true');
      var pez = D.createElement('img'); pez.src = C.huevo; pez.alt = ''; pez.className = 'shk-huevo__sharky';
      pez.style.width = tam + 'px';
      capa.appendChild(pez); D.body.appendChild(capa);
      var y0 = Math.round(alto * 0.42), dur = RM ? 0 : 3600;
      if (RM || !pez.animate) { setTimeout(function () { capa.remove(); nadando = false; }, 1200); return; }
      pez.animate([
        { transform: 'translate(' + (-tam - 20) + 'px,' + y0 + 'px) rotate(2deg)' },
        { transform: 'translate(' + (ancho * 0.25 - tam / 2) + 'px,' + (y0 - 26) + 'px) rotate(-3deg)', offset: 0.3 },
        { transform: 'translate(' + (ancho * 0.6 - tam / 2) + 'px,' + (y0 + 18) + 'px) rotate(3deg)', offset: 0.65 },
        { transform: 'translate(' + (ancho + 20) + 'px,' + (y0 - 10) + 'px) rotate(-2deg)' }
      ], { duration: dur, easing: 'cubic-bezier(.35,.05,.45,1)', fill: 'forwards' }).onfinish = function () { capa.remove(); nadando = false; };
      /* burbujas que va dejando */
      for (var i = 0; i < 14; i++) {
        (function (k) {
          setTimeout(function () {
            if (!pez.isConnected) return;
            var r = pez.getBoundingClientRect(), b = D.createElement('i');
            var d = 6 + Math.random() * 10;
            b.className = 'shk-huevo__burbuja';
            b.style.cssText = 'left:' + (r.left + r.width * 0.12) + 'px;top:' + (r.top + r.height * (0.35 + Math.random() * 0.3)) + 'px;width:' + d + 'px;height:' + d + 'px';
            capa.appendChild(b);
            b.animate([{ transform: 'translate(0,0) scale(.6)', opacity: 0 }, { opacity: .9, offset: .2 }, { transform: 'translate(' + (-20 - Math.random() * 30) + 'px,' + (-50 - Math.random() * 60) + 'px) scale(1)', opacity: 0 }], { duration: 1300 + Math.random() * 500, easing: 'ease-out', fill: 'forwards' });
          }, 300 + k * 220);
        })(i);
      }
    }
    D.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('.shk-nav__logo, .shk-stickybar__logo');
      if (!a) return;
      e.preventDefault();
      precarga();
      toques = Date.now() - reloj < 1600 ? toques + 1 : 1; reloj = Date.now();
      if (toques === 1) W.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' });
      if (toques >= 5) { toques = 0; nada(); }
    }, true);
  }

  /* ---------- 7. Portada: la primera foto del collage sale en 900 px y, al terminar de cargar la página, pasa a la nítida
     (1200 px en iPhone). Así llega antes y no pierde calidad: el pase de fotos empieza justo entonces. ---------- */
  function fotoNitida() {
    var f = $('img[data-shk-lcp]'); if (!f) return;
    function sube() { setTimeout(function () { f.setAttribute('sizes', '100vw'); }, 150); }
    if (D.readyState === 'complete') sube(); else W.addEventListener('load', sube, { once: true });
  }

  /* ---------- Ficha: todas las fotos del deslizador se descargan en cuanto la página ha cargado ----------
     En orden (la 2.ª primero), para que al pasar fotos no haya que esperar ninguna. Con «ahorro de datos», no. */
  function galeriaCompleta() {
    if (!esFicha() || ahorroDatos) return;
    function carga() {
      var imgs = $$('.Product__Gallery img.Image--lazyLoad, .Product__Slideshow img.Image--lazyLoad');
      if (!imgs.length || !W.lazySizes || !W.lazySizes.loader) return;
      imgs.forEach(function (img) { img.loading = 'eager'; img.setAttribute('fetchpriority', 'low'); W.lazySizes.loader.unveil(img); });
    }
    if (D.readyState === 'complete') setTimeout(carga, 50);
    else W.addEventListener('load', function () { setTimeout(carga, 50); }, { once: true });
  }

  function arranca() {
    fotoNitida();
    fotosALaVista();
    galeriaCompleta();
    armaEntradas();
    barraFicha();
    sharkyTv();
    huevo();
    preparaBolsas();
    pintaBolsa(total0, n0, true);
    carritoAlInstante();
    W.addEventListener('load', function () { setTimeout(armaEntradas, 300); });
    setTimeout(armaEntradas, 2500);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', arranca); else arranca();
})();
